module.exports = __webpack_public_path__ + "static/media/19ESCAP46.0be0bc64.jpg";